import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'

const TicketIncluded = () => {
    const { translate } = useTranslate()
    const contents = [
        translate('ticket_included_1'),
        translate('ticket_included_2'),
        translate('ticket_included_3'),
        translate('ticket_included_4'),
        translate('ticket_included_5')
    ]

    return (
        <Stack p={'48px 24px'} bgcolor={'secondary.main'} gap={3}>
            <Typography variant="h1" color="primary.main">
                {translate('ticket_included')}
            </Typography>
            <Stack>
                <UnorderedListStyled style={{ listStyle: 'outside', listStyleType: 'disc' }}>
                    {contents.map((content, index) => (
                        <li key={index} style={{ paddingTop: index > 0 ? '24px' : 0 }}>
                            <Typography variant="body1" color="primary.main" component={'span'}>
                                {content}
                            </Typography>
                        </li>
                    ))}
                </UnorderedListStyled>
            </Stack>
            <Stack>
                <Typography variant="body1" color="primary.main">
                    <strong>{translate('no_qualifications_necessary')}</strong> {translate('simply_buy_your_ticket_to_reserve_your_spot')}
                </Typography>
            </Stack>
        </Stack>
    )
}

const UnorderedListStyled = styled('ul')(({ theme }) => ({
    listStyle: 'outside',
    listStyleType: 'disc',
    paddingLeft: '1.2em',
    '& li': {
        paddingTop: theme.spacing(1),
        '::marker': {
            color: theme.palette.primary.main,
            marginRight: '4px'
        },
        listStylePosition: 'outside'
    }
}))

export default TicketIncluded
